export const actionTypes = {
    SET_ENERGY_VIEW_MODE: 'operationalParametersV2/SET_ENERGY_VIEW_MODE'
};

export const STACKED_AREA_CHART = 'StackedAreaChart';

export const energyViewModes = {
    OVERALL: 'overall',
    DETAILED: 'detailed'
};

export const energyConsumptionSignals = {
    MEASURED: 'measured',
    CALCULATED: 'calculated',
    PRODUCTION: 'production'
};
